'use client';

import Link from 'next/link';
import Image from 'next/image';
import { getName } from '@/libs/utils';

export default function Footer() {
  return (
    <footer className="bg-[rgba(249,115,22,0.1)] text-gray-400 py-5">
      <div className="container mx-auto px-8 max-w-7xl flex flex-col items-center">
        <Link href="/" className="mb-8 flex justify-center">
          <Image
            src="/assets/logo.png"
            alt="Logo"
            width={60}
            height={60}
            className="mx-auto"
            priority
          />
        </Link>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full justify-items-center text-center">
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><Link href="/" className="hover:text-orange-400 transition">Shop</Link></li>
              <li><Link href="/products" className="hover:text-orange-400 transition">Products</Link></li>
              <li><Link href="/faq" className="hover:text-orange-400 transition">FAQ</Link></li>
              <li><Link href="/support" className="hover:text-orange-400 transition">Support</Link></li>
              <li><Link href="/community" className="hover:text-orange-400 transition">Reviews</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link href="/terms" className="hover:text-orange-400 transition">Terms of Service</Link></li>
            </ul>
          </div>
        </div>


        <div className="mt-12 border-t border-gray-700 pt-6 text-center text-sm text-gray-500 w-full">
          &copy; {new Date().getFullYear()} `${getName(false)} -. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
